import Cookie from 'js-cookie';

export function getToken() {
  return Cookie.get(process.env.REACT_APP_TOKEN);
}

export async function isAuthenticated() {
  return true;
}
